<!-- 受け取るボタンをクリックして、確認のダイアログ -->
<template>
  <ItemDialog ref="recieveDialog" imageType="alert">
    <template v-slot:content-area>
      <p class="text-center">
        受け取り前に下記をご確認ください。<br />
        受け取ったチケットは自分では払い戻しできません。<br />
        払い戻ししたい場合は元の持ち主に返却する必要があります。<br />
        払い戻しや返却は有効期間中、利用開始前に限られます。<br />
      </p>
    </template>
    <template v-slot:button-area>
      <ItemButton label="OK" actionType="btn-primary" @clicked="clickOk()" />
      <ItemButton label="キャンセル" actionType="btn-cancel" @clicked="closeDialog()" />
    </template>
  </ItemDialog>

  <!-- ローディングダイアログ -->
  <DialogLoading ref="DialogLoading" />
  <DialogReceiveError ref="DialogReceiveError" />
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

// API
import API from "@/API";

import nativeHandlerService from "@/services/nativeHandler";
import DialogLoading from "@/views/Components/Organisms/Common/Dialog/DialogLoading";

export default {
  name: "DialogRecieve",
  components: {
    DialogLoading: DialogLoading,
  },
  setup() {
    const store = useStore();
    const route = useRoute();

    const DialogLoading = ref(null);
    const DialogReceiveError = ref(null);
    const recieveDialog = ref(null);

    const openDialog = () => {
      recieveDialog.value.open();
    };

    const closeDialog = () => {
      recieveDialog.value.close();
    };

    const clickOk = async () => {
      closeDialog();
      DialogLoading.value.openDialog();

      try {
        // 受け取り処理
        await API.postTransfer(route.query.key);
        DialogLoading.value.closeDialog();
        // nativeService呼ぶ
        nativeHandlerService.returnNativeAppMyticketPage();
      } catch (err) {
        DialogLoading.value.closeDialog();
        DialogReceiveError.value.openDialog(err.response.data.error);
      }
    };

    return {
      recieveDialog,
      openDialog,
      closeDialog,
      clickOk,
      DialogLoading,
      DialogReceiveError,
    };
  },
};
</script>
